export default __webpack_public_path__ + "static/media/accountmanager.42bcba72.svg";